import { type ReactNode } from 'react';
import {
  BODY,
  Bullet,
  PullQuote,
  Section,
  Subsection,
} from './rules-typography';

const GAME_OVER = (
  <strong className="font-semibold uppercase tracking-wider text-error">
    GAME OVER
  </strong>
);

function StrikesBlock(): ReactNode {
  return (
    <Subsection title="Strikes">
      <ul className={`${BODY} space-y-1.5`}>
        <Bullet>Mínimo diario: 33 creadores.</Bullet>
        <Bullet>Si no llegas al mínimo: 1 strike.</Bullet>
        <Bullet>3 strikes en 1 semana = {GAME_OVER}.</Bullet>
      </ul>
      <PullQuote>Los strikes se reinician cada semana.</PullQuote>
    </Subsection>
  );
}

function SanctionsBlock(): ReactNode {
  return (
    <Subsection title="Sanciones">
      <p className={BODY}>Te llevas una sanción si:</p>
      <ul className={`${BODY} space-y-1.5`}>
        <Bullet>Tiene email y no lo pones.</Bullet>
        <Bullet>Categoría incorrecta.</Bullet>
        <Bullet>«No sigue» y sí sigue a @ernestdift.</Bullet>
        <Bullet>Haces follow a @the3333games.</Bullet>
        <Bullet>No tiene +10 publicaciones coherentes.</Bullet>
      </ul>
      <p className={BODY}>
        Cada sanción descuenta <strong>10 creadores</strong> del top del tramo.
        No se pagan.
      </p>
    </Subsection>
  );
}

function MaxBlock(): ReactNode {
  return (
    <Subsection title="Máximo">
      <p className={BODY}>5 sanciones totales = {GAME_OVER}.</p>
      <PullQuote>Las sanciones NO se reinician.</PullQuote>
    </Subsection>
  );
}

function ClosingNote(): ReactNode {
  return (
    <p className={BODY}>
      Hay un equipo revisando todo. Los domingos se validan los creadores antes
      de pagar el lunes — se pagan los correctos restando los sancionados.
    </p>
  );
}

export function StrikesList(): ReactNode {
  return (
    <Section title="8. Strikes y sanciones">
      <StrikesBlock />
      <SanctionsBlock />
      <MaxBlock />
      <ClosingNote />
    </Section>
  );
}
